import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Projekte/Experimente/github/react-gsap/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Fragment } from 'react';
import { Playground, Props } from 'docz';
import { Controls, PlayState } from './../../../react-gsap/src/';
import { Timeline, TimelinePropsDummy, TargetWithNames } from './Timeline';
import { Tween } from './Tween';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "timeline"
    }}>{`Timeline`}</h1>
    <p>{`The Timeline component uses the `}<a parentName="p" {...{
        "href": "https://greensock.com/docs/v3/GSAP/Timeline"
      }}>{`gsap.timeline()`}</a>{` function internally.`}</p>
    <pre><code parentName="pre" {...{}}>{`import { Controls, PlayState, Timeline, Tween } from 'react-gsap';
`}</code></pre>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <p>{`You can add a target and control it with childless Tween components. The target needs to be a "refable" component.
So it can be a HTML element or a forwardRef component like a styled-components component.`}</p>
    <Playground __position={0} __code={'<Controls playState={PlayState.stop}>\n  <Timeline\n    target={\n      <div style={{ width: \'100px\', height: \'100px\', background: \'#ccc\' }} />\n    }\n  >\n    <Tween from={{ opacity: 0 }} to={{ opacity: 1 }} duration={2} />\n    <Tween to={{ x: \'200px\' }} />\n    <Tween to={{ rotation: 180 }} position=\"+=1\" />\n  </Timeline>\n</Controls>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Props,
      Controls,
      PlayState,
      Timeline,
      TimelinePropsDummy,
      TargetWithNames,
      Tween,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Controls playState={PlayState.stop} mdxType="Controls">
    <Timeline target={<div style={{
          width: '100px',
          height: '100px',
          background: '#ccc'
        }} />} mdxType="Timeline">
      <Tween from={{
            opacity: 0
          }} to={{
            opacity: 1
          }} duration={2} mdxType="Tween" />
      <Tween to={{
            x: '200px'
          }} mdxType="Tween" />
      <Tween to={{
            rotation: 180
          }} position="+=1" mdxType="Tween" />
    </Timeline>
  </Controls>
    </Playground>
    <h2 {...{
      "id": "other-tweens"
    }}>{`Other Tweens`}</h2>
    <p>{`You can also add other normal Tweens.`}</p>
    <Playground __position={1} __code={'<Controls playState={PlayState.stop}>\n  <Timeline\n    target={\n      <div style={{ width: \'100px\', height: \'100px\', background: \'#ccc\' }} />\n    }\n  >\n    <Tween from={{ opacity: 0 }} to={{ opacity: 1 }} duration={2} />\n    <Tween to={{ x: \'200px\' }} />\n    <Tween to={{ x: \'200px\' }} duration={1}>\n      <div style={{ width: \'100px\', height: \'100px\', background: \'red\' }} />\n    </Tween>\n  </Timeline>\n</Controls>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Props,
      Controls,
      PlayState,
      Timeline,
      TimelinePropsDummy,
      TargetWithNames,
      Tween,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Controls playState={PlayState.stop} mdxType="Controls">
    <Timeline target={<div style={{
          width: '100px',
          height: '100px',
          background: '#ccc'
        }} />} mdxType="Timeline">
      <Tween from={{
            opacity: 0
          }} to={{
            opacity: 1
          }} duration={2} mdxType="Tween" />
      <Tween to={{
            x: '200px'
          }} mdxType="Tween" />
      <Tween to={{
            x: '200px'
          }} duration={1} mdxType="Tween">
        <div style={{
              width: '100px',
              height: '100px',
              background: 'red'
            }} />
      </Tween>
    </Timeline>
  </Controls>
    </Playground>
    <h2 {...{
      "id": "multiple-targets"
    }}>{`Multiple targets`}</h2>
    <p>{`You can wrap multiple target components in a Fragment and target them with the array index with the `}<inlineCode parentName="p">{`target`}</inlineCode>{` prop from the Tween component.
If you don't add a target you transform all target components.`}</p>
    <Playground __position={2} __code={'<Controls playState={PlayState.stop}>\n  <Timeline\n    target={\n      <Fragment>\n        <div\n          style={{ width: \'100px\', height: \'100px\', background: \'#ccc\' }}\n        />\n        <div style={{ width: \'100px\', height: \'100px\', background: \'red\' }} />\n      </Fragment>\n    }\n  >\n    <Tween to={{ x: \'100px\' }} target={0} />\n    <Tween to={{ x: \'100px\' }} target={1} />\n    <Tween to={{ x: \'200px\' }} target={0} />\n    <Tween to={{ x: \'200px\' }} target={1} />\n    <Tween to={{ opacity: 0 }} />\n  </Timeline>\n</Controls>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Props,
      Controls,
      PlayState,
      Timeline,
      TimelinePropsDummy,
      TargetWithNames,
      Tween,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Controls playState={PlayState.stop} mdxType="Controls">
    <Timeline target={<Fragment mdxType="Fragment">
          <div style={{
            width: '100px',
            height: '100px',
            background: '#ccc'
          }} />
          <div style={{
            width: '100px',
            height: '100px',
            background: 'red'
          }} />
        </Fragment>} mdxType="Timeline">
      <Tween to={{
            x: '100px'
          }} target={0} mdxType="Tween" />
      <Tween to={{
            x: '100px'
          }} target={1} mdxType="Tween" />
      <Tween to={{
            x: '200px'
          }} target={0} mdxType="Tween" />
      <Tween to={{
            x: '200px'
          }} target={1} mdxType="Tween" />
      <Tween to={{
            opacity: 0
          }} mdxType="Tween" />
    </Timeline>
  </Controls>
    </Playground>
    <h2 {...{
      "id": "advanced-multiple-targets"
    }}>{`Advanced multiple targets`}</h2>
    <p>{`If you need to target individual elements you can use a special forwardRef component with useImperativeHandle hook.`}</p>
    <p>{`In this way these component can be better reused and the refs not only work in a Timeline target context.`}</p>
    <p>{`You can also pass an array ref like seen with div2. In this way you can use the `}<inlineCode parentName="p">{`stagger`}</inlineCode>{` prop.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const TargetWithNames = forwardRef((props, ref) => {
  const div1 = useRef(null);
  const div2 = useRef([]);
  const div3 = useRef(null);
  useImperativeHandle(ref, () => ({
    div1,
    div2,
    div3,
  }));
  return (
    <div style={{ textAlign: 'center' }}>
      <h3 ref={div1}>THIS</h3>
      <SplitChars
        ref={charRef => div2.current.push(charRef)}
        wrapper={<h3 style={{ display: 'inline-block' }} />}
      >
        TEST
      </SplitChars>
      <h3 ref={div3}>IS A</h3>
    </div>
  );
});

`}</code></pre>
    <p>{`If you want to combine multiple of those named components, you can do it like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const TargetWithNamesCombined = forwardRef((props, ref) => {
  const target1 = useRef({});
  const target2 = useRef({});
  useImperativeHandle(ref, () => ({
    ...target1.current,
    ...target2.current,
  }));
  return (
    <>
      <TargetWithNames1 ref={target1} />
      <TargetWithNames2 ref={target2} />
    </>
  );
});

`}</code></pre>
    <p>{`For version < 3:`}</p>
    <p>{`If you need to target individual elements you can use a special forwardRef function.
The `}<inlineCode parentName="p">{`targets`}</inlineCode>{` parameter provide the `}<inlineCode parentName="p">{`set`}</inlineCode>{` function, which you can use to set a ref to a certain key.`}</p>
    <p>{`If you use an array as value, as seen in the example, you can save multiple elements as array under one key and use e.g. the `}<inlineCode parentName="p">{`stagger`}</inlineCode>{` prop.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const TargetWithNames = forwardRef((props, targets) => (
  <div style={{ textAlign: 'center' }}>
    <h3 ref={div => targets.set('div1', div)}>THIS</h3>
    <SplitChars
      ref={(div: ReactElement) => targets.set('div2', [div])}
      wrapper={<h3 style={{ display: 'inline-block' }} />}
    >
      TEST
    </SplitChars>
    <h3 ref={div => targets.set('div3', div)}>IS A</h3>
  </div>
));

`}</code></pre>
    <Playground __position={3} __code={'<Controls playState={PlayState.stop}>\n  <Timeline target={<TargetWithNames />}>\n    <Tween from={{ x: \'-100vw\' }} target=\"div1\" position=\"0\" />\n    <Tween from={{ x: \'-100vw\' }} target=\"div2\" position=\"2\" stagger={0.1} />\n    <Tween from={{ x: \'-100vw\' }} target=\"div3\" position=\"1\" />\n  </Timeline>\n</Controls>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Props,
      Controls,
      PlayState,
      Timeline,
      TimelinePropsDummy,
      TargetWithNames,
      Tween,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Controls playState={PlayState.stop} mdxType="Controls">
    <Timeline target={<TargetWithNames mdxType="TargetWithNames" />} mdxType="Timeline">
      <Tween from={{
            x: '-100vw'
          }} target="div1" position="0" mdxType="Tween" />
      <Tween from={{
            x: '-100vw'
          }} target="div2" position="2" stagger={0.1} mdxType="Tween" />
      <Tween from={{
            x: '-100vw'
          }} target="div3" position="1" mdxType="Tween" />
    </Timeline>
  </Controls>
    </Playground>
    <h2 {...{
      "id": "nested-timelines"
    }}>{`Nested Timelines`}</h2>
    <p>{`You can nest other Timelines or HTML structures.`}</p>
    <Playground __position={4} __code={'<Controls playState={PlayState.stop}>\n  <Timeline\n    target={\n      <div style={{ width: \'100px\', height: \'100px\', background: \'#ccc\' }} />\n    }\n  >\n    <Tween from={{ scaleX: 0.5, scaleY: 0.5 }} duration={2} />\n    <Tween to={{ x: \'200px\' }} />\n    <div>\n      <p>Other Timeline:</p>\n      <Timeline\n        target={\n          <div\n            style={{ width: \'100px\', height: \'100px\', background: \'red\' }}\n          />\n        }\n      >\n        <Tween from={{ scaleX: 0.5, scaleY: 0.5 }} duration={2} />\n        <Tween to={{ x: \'200px\' }} />\n      </Timeline>\n    </div>\n  </Timeline>\n</Controls>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Props,
      Controls,
      PlayState,
      Timeline,
      TimelinePropsDummy,
      TargetWithNames,
      Tween,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Controls playState={PlayState.stop} mdxType="Controls">
    <Timeline target={<div style={{
          width: '100px',
          height: '100px',
          background: '#ccc'
        }} />} mdxType="Timeline">
      <Tween from={{
            scaleX: 0.5,
            scaleY: 0.5
          }} duration={2} mdxType="Tween" />
      <Tween to={{
            x: '200px'
          }} mdxType="Tween" />
      <div>
        <p>Other Timeline:</p>
        <Timeline target={<div style={{
              width: '100px',
              height: '100px',
              background: 'red'
            }} />} mdxType="Timeline">
          <Tween from={{
                scaleX: 0.5,
                scaleY: 0.5
              }} duration={2} mdxType="Tween" />
          <Tween to={{
                x: '200px'
              }} mdxType="Tween" />
        </Timeline>
      </div>
    </Timeline>
  </Controls>
    </Playground>
    <h2 {...{
      "id": "label-support"
    }}>{`Label support`}</h2>
    <p>{`You can add labels to the timeline and use them in the position prop of the Tweens or nested Timelines.`}</p>
    <p>{`More info: `}<a parentName="p" {...{
        "href": "https://greensock.com/docs/v3/GSAP/Timeline/addLabel()"
      }}>{`https://greensock.com/docs/v3/GSAP/Timeline/addLabel()`}</a></p>
    <Playground __position={5} __code={'<Controls playState={PlayState.stop}>\n  <Timeline\n    target={\n      <div style={{ width: \'100px\', height: \'100px\', background: \'#ccc\' }} />\n    }\n    labels={[\n      {\n        label: \'sec4\',\n        position: 4,\n      },\n      {\n        label: \'sec6\',\n        position: 6,\n      },\n    ]}\n  >\n    <Tween from={{ opacity: 0 }} to={{ opacity: 1 }} duration={2} />\n    <Tween to={{ x: \'200px\' }} />\n    <Tween to={{ rotation: 180 }} position=\"sec4\" />\n    <Tween to={{ x: \'0px\' }} position=\"sec6\" />\n  </Timeline>\n</Controls>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Props,
      Controls,
      PlayState,
      Timeline,
      TimelinePropsDummy,
      TargetWithNames,
      Tween,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Controls playState={PlayState.stop} mdxType="Controls">
    <Timeline target={<div style={{
          width: '100px',
          height: '100px',
          background: '#ccc'
        }} />} labels={[{
          label: 'sec4',
          position: 4
        }, {
          label: 'sec6',
          position: 6
        }]} mdxType="Timeline">
      <Tween from={{
            opacity: 0
          }} to={{
            opacity: 1
          }} duration={2} mdxType="Tween" />
      <Tween to={{
            x: '200px'
          }} mdxType="Tween" />
      <Tween to={{
            rotation: 180
          }} position="sec4" mdxType="Tween" />
      <Tween to={{
            x: '0px'
          }} position="sec6" mdxType="Tween" />
    </Timeline>
  </Controls>
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <p>{`The question mark means it's an optional prop.`}</p>
    <p>{`For all available props check out the documentation: `}<a parentName="p" {...{
        "href": "https://greensock.com/docs/v3/GSAP/Timeline/vars"
      }}>{`vars`}</a></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`React.ReactNode`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Can be any component type. But Tween and other Timeline components are controlled by this Timeline`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`wrapper?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`React.ReactElement`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This component gets wrapped around the Timeline component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`target?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`React.ReactElement `}{`|`}{` null`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The target component that gets outputted and tweened from all childless Tween child components`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`position?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string `}{`|`}{` number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`If this Timeline is a child from another Timeline it's added at this position`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`labels?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Label[]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Can be used to give the positions a name`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`duration?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adjusts the Timeline's timeScale to fit it within the specified duration (Can be changed on-the-fly)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`progress?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0 - 1 (Can be changed on-the-fly)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`totalProgress?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0 - 1 (Can be changed on-the-fly)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`playState?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`PlayState`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Use it to control the playing state (Can be changed on-the-fly)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`[prop: string]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`any`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`All other props are added to the vars object for the gsap.timeline function`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "type-label"
    }}>{`Type Label`}</h2>
    <p>{`More info: `}<a parentName="p" {...{
        "href": "https://greensock.com/docs/v3/GSAP/Timeline/addLabel()"
      }}>{`https://greensock.com/docs/v3/GSAP/Timeline/addLabel()`}</a></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`label`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`position`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string `}{`|`}{` number`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "enum-playstate"
    }}>{`Enum PlayState`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Field`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`As string`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`play`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"play"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`restart`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"restart"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`reverse`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"reverse"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`restartReverse`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"restartReverse"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stop`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"stop"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stopEnd`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"stopEnd"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`pause`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"pause"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`resume`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`"resume"`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      